export default __webpack_public_path__ + "static/media/TWN.8ca08ed5.svg";